import ReservationListings from "../../Components/Reservations/ReservationListings";

export default function ReservationListing() {
    return (
        <ReservationListings />
    )
}